// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popup-parent--hidden .fixed-header {\n  padding-right: 15px;\n}\n.height-100vh {\n  height: 100vh;\n  min-height: 100vh;\n}", ""]);
// Exports
module.exports = exports;
